// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewHistory-SuccessIcon_cls1__lBdzf","cls2":"PaymentViewHistory-SuccessIcon_cls2__9PMSe PaymentViewHistory-SuccessIcon_cls1__lBdzf"};